import { Pipe, PipeTransform } from '@angular/core';

import { User } from '@core/services/user';

@Pipe({
  name: 'adviserName'
})
export class AdviserNamePipe implements PipeTransform {
  transform(portfolioId: string | null | undefined, users: User[]): string {
    if (!portfolioId || !users || users.length === 0) {
      return '';
    }
    return users.find((u) => u.portfolioId === portfolioId)?.displayName || '';
  }
}
